export enum REWARDS_DISCOUNT_TYPES {
    percentage = "percentage",
    fixedAmount = "fixed_amount",
    freeShipping = "free_shipping",
}

export type REWARDS_DISCOUNT_TYPE = `${REWARDS_DISCOUNT_TYPES}`;

export enum REWARDS_DISCOUNT_STATUS {
    active = "active",
    used = "used",
    expired = "expired",
    deleted = "deleted",
    refunded = "refunded",
    enabled = "enabled",
    disabled = "disabled",
}
